<template>
  <header id="page-topbar" style="background: #343dba">
     <div class="navbar-header">
        <div class="d-flex">
           <!-- LOGO -->
           <div class="navbar-brand-box">
              <router-link :to="{name: 'servers'}" class="logo logo-dark">
              <span class="logo-sm">
              <img src="../../assets/images/Monochrome-Alt@1x.svg" alt="" height="22">
              </span>
              <span class="logo-lg">
              <img src="../../assets/images/SPACEMINE-latest.svg" alt="" height="17">
              </span>
              </router-link>
              <router-link :to="{name: 'servers'}" class="logo logo-light">
              <span class="logo-sm">
              <img src="../../assets/images/Monochrome-Alt@1x.svg" alt="" height="22">
              </span>
              <span class="logo-lg">
              <img src="../../assets/images/SPACEMINE-latest.svg" alt="" height="19">
              </span>
              </router-link>
           </div>
           <button type="button" class="btn btn-sm px-3 font-size-16 d-lg-none header-item waves-effect waves-light" data-toggle="collapse" data-target="#topnav-menu-content">
           <i class="fa fa-fw fa-bars"></i>
           </button>
        </div>
        <div class="d-flex">
           <div class="dropdown d-inline-block">
              <button type="button" class="btn header-item waves-effect"
                 data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img class="" src="../../assets/images/flags/us.jpg" alt="Header Language" height="16">
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                 <!-- item-->
                 <a href="javascript:void(0);" class="dropdown-item notify-item">
                 <img src="../../assets/images/flags/spain.jpg" alt="user-image" class="mr-1" height="12"> <span class="align-middle">Spanish</span>
                 </a>
                 <!-- item-->
                 <a href="javascript:void(0);" class="dropdown-item notify-item">
                 <img src="../../assets/images/flags/germany.jpg" alt="user-image" class="mr-1" height="12"> <span class="align-middle">German</span>
                 </a>
                 <!-- item-->
                 <a href="javascript:void(0);" class="dropdown-item notify-item">
                 <img src="../../assets/images/flags/italy.jpg" alt="user-image" class="mr-1" height="12"> <span class="align-middle">Italian</span>
                 </a>
                 <!-- item-->
                 <a href="javascript:void(0);" class="dropdown-item notify-item">
                 <img src="../../assets/images/flags/russia.jpg" alt="user-image" class="mr-1" height="12"> <span class="align-middle">Russian</span>
                 </a>
              </div>
           </div>
           <div class="dropdown d-inline-block">
              <button type="button" class="btn header-item noti-icon waves-effect" id="page-header-notifications-dropdown"
                 data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="bx bx-bell"></i>
              <span class="badge badge-danger badge-pill">3</span>
              </button>
              <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
                 aria-labelledby="page-header-notifications-dropdown">
                 <div class="p-3">
                    <div class="row align-items-center">
                       <div class="col">
                          <h6 class="m-0"> Notifications </h6>
                       </div>
                       <div class="col-auto">
                          <a href="#!" class="small"> View All</a>
                       </div>
                    </div>
                 </div>
                 <div data-simplebar style="max-height: 230px;">
                    <a href="" class="text-reset notification-item">
                       <div class="media">
                          <div class="avatar-xs mr-3">
                             <span class="avatar-title bg-primary rounded-circle font-size-16">
                             <i class="bx bx-cart"></i>
                             </span>
                          </div>
                          <div class="media-body">
                             <h6 class="mt-0 mb-1">Your order is placed</h6>
                             <div class="font-size-12 text-muted">
                                <p class="mb-1">If several languages coalesce the grammar</p>
                                <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 3 min ago</p>
                             </div>
                          </div>
                       </div>
                    </a>
                    <a href="" class="text-reset notification-item">
                       <div class="media">
                          <img src="../../assets/images/users/avatar-3.jpg"
                             class="mr-3 rounded-circle avatar-xs" alt="user-pic">
                          <div class="media-body">
                             <h6 class="mt-0 mb-1">James Lemire</h6>
                             <div class="font-size-12 text-muted">
                                <p class="mb-1">It will seem like simplified English.</p>
                                <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 1 hours ago</p>
                             </div>
                          </div>
                       </div>
                    </a>
                    <a href="" class="text-reset notification-item">
                       <div class="media">
                          <div class="avatar-xs mr-3">
                             <span class="avatar-title bg-success rounded-circle font-size-16">
                             <i class="bx bx-badge-check"></i>
                             </span>
                          </div>
                          <div class="media-body">
                             <h6 class="mt-0 mb-1">Your item is shipped</h6>
                             <div class="font-size-12 text-muted">
                                <p class="mb-1">If several languages coalesce the grammar</p>
                                <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 3 min ago</p>
                             </div>
                          </div>
                       </div>
                    </a>
                    <a href="" class="text-reset notification-item">
                       <div class="media">
                          <img src="../../assets/images/users/avatar-4.jpg"
                             class="mr-3 rounded-circle avatar-xs" alt="user-pic">
                          <div class="media-body">
                             <h6 class="mt-0 mb-1">Salena Layfield</h6>
                             <div class="font-size-12 text-muted">
                                <p class="mb-1">As a skeptical Cambridge friend of mine occidental.</p>
                                <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 1 hours ago</p>
                             </div>
                          </div>
                       </div>
                    </a>
                 </div>
                 <div class="p-2 border-top">
                    <a class="btn btn-sm btn-link font-size-14 btn-block text-center" href="javascript:void(0)">
                    <i class="mdi mdi-arrow-right-circle mr-1"></i> View More..
                    </a>
                 </div>
              </div>
           </div>
           <div class="dropdown d-inline-block">
              <button type="button" class="btn header-item waves-effect" id="page-header-user-dropdown"
                 data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img class="rounded-circle header-profile-user" :src="profileImage"
                 alt="Profile Pic">
              <span class="d-none d-xl-inline-block ml-1">{{ name }}</span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                 <!-- item-->
                 <a class="dropdown-item" href="#"><i class="bx bx-user font-size-16 align-middle mr-1"></i> Profile</a>
                 <a class="dropdown-item" href="#"><i class="bx bx-wallet font-size-16 align-middle mr-1"></i> My Wallet</a>
                 <a class="dropdown-item d-block" href="#"><span class="badge badge-success float-right">11</span><i class="bx bx-wrench font-size-16 align-middle mr-1"></i> Settings</a>
                 <a class="dropdown-item" href="#"><i class="bx bx-lock-open font-size-16 align-middle mr-1"></i> Lock screen</a>
                 <div class="dropdown-divider"></div>
                 <a v-on:click="logout" class="dropdown-item text-danger"><i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i> Logout</a>
              </div>
           </div>
        </div>
     </div>
  </header>
</template>

<script>
import store from '../../store'
export default
{
  name: 'NavBar',
  data () {
    return { }
  },
  computed:
  {
    name () {
      return store.state.name
    },
    profileImage () {
      return store.state.profileUrl
    }
  },
  methods: {
    logout () {
      store.dispatch('logout')
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/elements/NavBar.vue